import React, { Component } from 'react'
import api from './../../api/index';
import { Link } from 'react-router-dom';

export default class BusinessCategoryDetail extends Component {
    state = {
        discription: ''
    }
    getBusinessCategory = async () => {
        console.log('this.props.match.params.id', this.props.match.params.id)
        try {
            const res = await api.get(`business/category/${this.props.match.params.id}`);
            console.log('res', res)
            this.setState({ discription: res.data.data.category.discription })
        } catch (error) {

        }
    }
    componentDidMount() {
        this.getBusinessCategory()
    }
    componentDidUpdate(prevProp, prevState) {
        if (this.props.match.params.id !== prevProp.match.params.id) {
            this.getBusinessCategory();
        }
    }
    render() {
        return (
            <div>
                <section className="section-businessCategoryDetail">
                    <Link to='/' style={{ color: 'black', fontWeight: 'bold' }}> <i class="fas fa-chevron-left"></i> Back to Home</Link>
                    <div className="p-4" dangerouslySetInnerHTML={{ __html: this.state.discription }}></div>
                </section>
            </div>
        )
    }
}
